import { Color } from "@videosmart/player-template";
import { colorToHsl } from "./colorToHsl";

export const calculateHighlightColor = (backgroundColor: Color): Color => {
  if (backgroundColor.alpha < 0.2 || colorToHsl(backgroundColor)[2] < 0.5) {
    return {
      red: 255,
      green: 255,
      blue: 255,
      alpha: 0.1
    };
  } else {
    return {
      red: 0,
      green: 0,
      blue: 0,
      alpha: 0.1
    };
  }
}